import React from 'react/addons'
import formatNumber from 'lib/formatNumber'
import inCart from 'lib/inCart'
import splitTitle from './splitTitle'

let cx = React.addons.classSet

const Tbl = React.createClass({

	handleCartBtnClick(add, id) {
		add
			? this.props.onAddToCart(this.props.productId, id)
			: this.props.onRemoveFromCart(this.props.productId, id)
	},

	renderCartButton(id) {
		let done = inCart(this.props.cart.items, id, this.props.productId)
		let cl = cx({
			'cart-btn': true,
			'done': done
		})

		return <div className={cl}>
			<a onClick={this.handleCartBtnClick.bind(this, !done, id)}>
				{done ? 'Убрать из корзины' : 'В корзину'}
			</a>
		</div>
	},

	renderRow(id, row) {
		let lens = this.props.lens
		return <tr key={id}>
			{row.map((cell, i) => <td key={i} className={lens[i] ? 'is-digit' : ''} dangerouslySetInnerHTML={{__html: lens[i] ? formatNumber(cell, lens[i][0], lens[i][1], '&nbsp;&nbsp;') : cell}} />)}
			<td>{this.renderCartButton(id)}</td>
		</tr>
	},

	render () {
		return (
			<table>
				<thead>
					<tr>
						{this.props.cols.map((col, i) => <th key={i} dangerouslySetInnerHTML={{__html: splitTitle(col || '')}} />)}
						<th></th>
					</tr>
				</thead>
				<tbody>
					{Object.keys(this.props.data).map(id => this.renderRow(id, this.props.data[id]))}
				</tbody>
			</table>
		)
	}

})

module.exports = Tbl


/** WEBPACK FOOTER **
 ** ./src/scripts/components/SimpleTableApp/Tbl.js
 **/